import { createAction, props, ActionCreator } from '@ngrx/store';
import { capitalize } from 'lodash-es';
import { DataTablePagination, DataTablePaginationTotal, DataTableSort } from 'studio-components';
import { createLoadActions, LoadActions, LoadSucceededProps } from '../load/actions';
import { StringTypedAction } from '../types';

export type PaginationChangedProps = {
  pagination: DataTablePagination;
};

export type SortChangedProps = {
  sort: DataTableSort;
};

export interface LoadSucceededWithPaginationProps<Entity>
  extends LoadSucceededProps<Entity>,
    DataTablePagination,
    DataTablePaginationTotal {}

export type PaginationChangedAction = ActionCreator<
  string,
  (props: PaginationChangedProps) => PaginationChangedProps & StringTypedAction
>;

export type SortChangedAction = ActionCreator<
  string,
  (props: SortChangedProps) => SortChangedProps & StringTypedAction
>;

export type LoadWithPaginationSucceededAction<Entity> = ActionCreator<
  string,
  (
    props: LoadSucceededWithPaginationProps<Entity>,
  ) => LoadSucceededWithPaginationProps<Entity> & StringTypedAction
>;

export interface LoadWithPaginationActions<Entity> extends LoadActions<Entity> {
  paginationChanged: PaginationChangedAction;
  sortChanged: SortChangedAction;
  loadSucceeded: LoadWithPaginationSucceededAction<Entity>;
}

export function createLoadWithPaginationActions<Entity>(
  type: string,
): LoadWithPaginationActions<Entity> {
  const Type = `[${capitalize(type)}]`;
  const loadActions = createLoadActions<Entity>(type);

  return {
    ...loadActions,
    loadSucceeded: createAction(
      `${Type} Load Succeeded`,
      props<LoadSucceededWithPaginationProps<Entity>>(),
    ),
    paginationChanged: createAction(`${Type} Pagination Changed`, props<PaginationChangedProps>()),
    sortChanged: createAction(`${Type} Sort Changed`, props<SortChangedProps>()),
  };
}
